import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '业务规则',
    type: 'BD_RULE',
}
